// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"32a4a784","788":"55d3cea0"}[chunkId] + ".chunk.js";
};